import '@/assets/style/custom-controls.sass'
import '@/assets/style/popup.sass'
import '@/assets/style/alert-animation.sass'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'ol-ext/dist/ol-ext.min.css'
import 'ol/ol.css'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// eslint-disable-next-line
const vueKeepScroll = require('vue-keep-scroll-position')

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(vueKeepScroll)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
